import usePaginatedLogList from "../../../hooks/usePaginatedLogList";
import LogListError from "../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button,  Select, Table } from "antd";
import { useNavigate } from "react-router-dom";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const DailyConsumptionList = () => {
  const navigate = useNavigate();
  const { data: filteredData, loading: page_loader, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.list_daily_consumption_logs, "logs");
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          DAILY_CONSUMPTION_LIST_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  const DAILY_CONSUMPTION_LIST_API = (ship_id) => {
    if (!ship_id) return;
    return loadRecords({ ship_id });
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "daily_consumption_log_id",
      align: "center",
      key: "daily_consumption_log_id",
      sorter: (a, b) => a.daily_consumption_log_id - b.daily_consumption_log_id,
    },
    {
      title: "Type of event",
      dataIndex: "type_of_event",
      align: "center",
      key: "type_of_event",
    },
    {
      title: "Stay",
      dataIndex: "stay",
      align: "center",
      key: "stay",
    },

    {
      title: "RPM",
      dataIndex: "rpm",
      align: "center",
      key: "rpm",
    },
    {
      title: "Speed",
      dataIndex: "speed",
      align: "center",
      key: "speed",
    },
    {
      title: "Slip",
      dataIndex: "slip",
      align: "center",
      key: "slip",
    },
    {
      title: "Engine Distance",
      dataIndex: "engine_distance",
      align: "center",
      key: "engine_distance",
    },
    {
      title: "Date",
      dataIndex: "log_date",
      align: "center",
      key: "log_date",
      render: (text, record) => formatDate(record?.log_date),
    },
    {
      title: "Time",
      dataIndex: "log_time",
      align: "center",
      key: "log_time",
      width: 100, // or any value that fits
      render: (text) => text || "-",
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              DAILY_CONSUMPTION_LIST_API(value);
            }}
          >
            {ship_table_list?.length > 0 && (
              <>
                {ship_table_list.map((ship) => (
                  <>
                    {!ship.soft_delete && (
                      <>
                        <Select.Option key={ship.id} value={ship.id}>
                          {ship.vessel_name}
                        </Select.Option>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Daily Ship Staff Task</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/audit-trail-daily-comsumption")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <LogListError error={error} retry={retry} />
      <Table
        bordered
        loading={page_loader}
        columns={columns}
        dataSource={filteredData}
        pagination={pagination}
        rowKey="daily_consumption_log_id"
        className="custom-table"
      />
    </>
  );
};

export default DailyConsumptionList;
